import LoadingSpinner from 'gcs-common/design-system/ui/loading-spinner';
import { getFavicon, getThemeIdentifier } from 'gcs-common/slices/theme/themeSelectors';
import { useSelector } from 'react-redux';

const LoadingPage = () => {
  const theme = useSelector(getThemeIdentifier);
  const logo = useSelector(getFavicon);

  return (
    <div className="flex h-screen justify-center">
      <div className="mt-60 flex h-screen w-full max-w-xs flex-col items-center gap-4 space-y-3 text-center">
        <img alt={`${theme}-icon`} src={logo} className="size-[60px] rounded-lg" />
        <p className="text-2xl">Beem lädt...</p>
        <LoadingSpinner />
      </div>
    </div>
  );
};

export default LoadingPage;
